'use client';
import { jsxs as m, jsx as r } from "react/jsx-runtime";
import * as a from "@radix-ui/react-checkbox";
import { Icon as h } from "@tameeni/icons";
import { cn as i } from "@tameeni/shared-logic";
import * as s from "react";
import { Label as b } from "../label/label.js";
const f = s.forwardRef(({ className: o, id: c, label: e = "", ...d }, n) => {
  const l = s.useId();
  let t = c;
  return t || (typeof e == "string" ? t = e : t = l), /* @__PURE__ */ m("div", { className: "flex items-center gap-2 group min-w-fit", children: [
    /* @__PURE__ */ r(
      a.Root,
      {
        ref: n,
        id: t,
        "aria-label": typeof e == "string" && e || "checkbox",
        className: i(
          `border border-slate-400 hover:border-green
          disabled:cursor-not-allowed disabled:bg-slate-100
          peer rounded-xs h-5 w-5 shrink-0 transition-all duration-100
          disabled:border-slate-300 hover:disabled:border-slate-300
          data-[state=checked]:bg-green data-[state=checked]:border-green
          focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring
          hover:data-[state=checked]:bg-green-700 hover:data-[state=checked]:border-green-700
          disabled:data-[state=checked]:text-slate-400 disabled:data-[state=checked]:bg-slate-100
          disabled:data-[state=checked]:border-slate-300
          data-[state=checked]:text-white
          data-[state=indeterminate]:bg-green data-[state=indeterminate]:border-green
          data-[state=indeterminate]:text-white`,
          o
        ),
        ...d,
        children: /* @__PURE__ */ r(
          a.Indicator,
          {
            className: i("flex items-center justify-center text-current"),
            children: /* @__PURE__ */ r(
              h,
              {
                className: "size-3",
                name: d.checked === "indeterminate" ? "Minus" : "Checked"
              }
            )
          }
        )
      }
    ),
    e && /* @__PURE__ */ r(b, { htmlFor: t, className: "cursor-pointer text-inherit", children: e })
  ] });
});
f.displayName = a.Root.displayName;
export {
  f as Checkbox
};
